/**
 * Created by Nisarg on 7/19/2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {Link, withRouter} from 'react-router-dom';
import Autosuggest from 'react-autosuggest';
import $ from 'jquery';
import firebase from 'firebase';
import _HauteFire from './HauteFire';

const HauteFire = new _HauteFire();

export default class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {value: '', AllIslands: [], CopyAllIslands: []};
    }

    componentDidMount() {
        const _this = this;
        let islandRef = firebase.database().ref("IslandDetails");
        islandRef.orderByChild("name").on("value", (response) => {
            const Islands = response.val();
            if (Islands != null) {
                const keys = Object.keys(Islands);
                let CopyAllIslands = [];
                keys.map((key) => {
                    CopyAllIslands.push({name: Islands[key].name, address: Islands[key].address})
                });
                if (CopyAllIslands.length > 0) {
                    _this.setState({CopyAllIslands});
                }
            }
        });

        $("input.react-autosuggest__input").addClass("search");
        $(document).on("click", "body", this.hideSearchResult.bind(this));
        // $(document).on("click", ".search-btn", this.searchFormClick.bind(this));
    }

    searchFormClick(e) {
        e.stopPropagation();
        $(".search-form").addClass("expand");
        $("input.react-autosuggest__input").addClass("expand-size");
        if (!HauteFire.isMobile()) {
            $("input.react-autosuggest__input").css({width: '240px'});
        }
        $("input.react-autosuggest__input").show().focus();
    }

    hideSearchResult(e) {
        $(".search-form input").removeClass("expand-size");
        $(".search-form").removeClass("expand");

        $("input.react-autosuggest__input").hide();
        this.setState({value: "", AllIslands: []});
    }

    getSuggestions = (value) => {
        let restuls = this.state.CopyAllIslands.filter(island => island.name.toLowerCase().includes(value.trim().toLocaleLowerCase()) || island.address.toLowerCase().includes(value.trim().toLocaleLowerCase()));
        return restuls = restuls.map((island) => {
            return island.name
        })
    }

    getSuggestionValue = (suggestion) => {
        return suggestion;
    }

    onSuggestionSelected(event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) {
        this.context.router.history.push('/island/' + suggestion);

        // history.push("/island/" + suggestion);
        // this.props.history.push("/island/" + suggestion);
        // this.props.history.pushState(null, "/island/" + suggestion);
    }

    renderSuggestion = (suggestion) => {
        /* <div>{suggestion}</div>*/

        return (
            <Link to={"/island/" + suggestion}>{suggestion}</Link>
        );
    }

    onChange = (event, {newValue, method}) => {
        this.setState({
            value: newValue
        });
    };

    onSuggestionsFetchRequested = ({value}) => {
        this.setState({
            AllIslands: this.getSuggestions(value)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            AllIslands: []
        });
    };

    render() {
        const {value, AllIslands} = this.state;
        const inputProps = {
            placeholder: 'Search island',
            value,
            onChange: this.onChange
        };

        const propTypes = {
            match: PropTypes.object.isRequired,
            location: PropTypes.object.isRequired,
            history: PropTypes.object.isRequired
        }

        this.props = {match: propTypes.match, location: propTypes.location, history: propTypes.history};

        return (
            <header className="header clearfix">
                <Link className="logo" to="/"><img src="../../assets/images/logo-h.png" alt=""/></Link>
                <div className="header-sec ">
                    <div className="header-l-sec">
                        <a className="menu" href="#0">
                            <span></span>
                            <span></span>
                            <span></span>
                        </a>
                        <Link className="sticky-logo" to="/">
                            <img src="../../assets/images/logo.png" alt="logo"/></Link>

                        <nav className="header-list">
                            <ul className="nav-menu-parent">
                                <li className="nav-menu"><Link to="/private_islands">PRIVATE ISLANDS</Link></li>
                                <li className="nav-menu"><Link to="/romantic_islands">ROMANCE</Link></li>
                                <li className="nav-menu"><Link to="/party_islands">PARTY</Link></li>
                                <li className="nav-menu"><Link to="/family_islands">FAMILY</Link></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="header-r-sec">
                        {/*
                         <ul className="clearfix">
                         <li className="login"><a href="#">
                         LOG IN
                         </a></li>
                         <li><a href="#">
                         ABOUT
                         </a></li>
                         </ul>

                         <form className="search-form">
                         <input type="text" className="search"/>


                         <button className="search-btn" type="button"><i className="icon-search"></i></button>
                         </form>
                        */}

                        <form className="search-form">

                            <Autosuggest
                                suggestions={AllIslands}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue.bind(this)}
                                onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={inputProps}/>

                            <button className="search-btn" type="button"><i
                                className="fa fa-search"></i></button>
                        </form>


                    </div>

                </div>
            </header>
        )
    }
}

Header.contextTypes = {
    router: React.PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/Header.js